// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3H9qx","title":"Info_title__3MIPm","links":"Info_links__3jfNr","link":"Info_link__3TM4U","logo":"Info_logo__3cpGB"};